/**
 * The app's one client (API_ACCESS.md §3.4), made on first use from the axios transport and the
 * capability engine, as `capabilities()` is: no app wires it, and nothing runs at module load. A
 * test registers its own and restores the previous one.
 */
import { capabilities } from "../capabilities/registry";
import store from "../redux-store";
import { createApiClient } from "./client";
import type { Route } from "./route";
import { createSagaCall, type SagaCall } from "./sagaCall";
import { axiosTransport } from "./transport/axios";
import type { ApiClient } from "./types";

let instance: ApiClient | null = null;

export function apiClient(): ApiClient {
  instance ??= createApiClient({ transport: axiosTransport, access: capabilities() });
  return instance;
}

/** returns the restore */
export function registerApiClient(next: ApiClient): () => void {
  const previous = instance;
  instance = next;
  return () => {
    instance = previous;
  };
}

/** a gated dispatch into a shared saga, bound to the app's store and client (`./sagaCall`) */
export function sagaCall<Payload>(actionCreator: (payload: Payload) => unknown, routes: readonly Route<any, any, any>[]): SagaCall<Payload> {
  return createSagaCall(actionCreator, routes, () => ({ dispatch: store.dispatch, canCall: apiClient().canCall }));
}
